import { useEffect } from 'react';

/**
 * Met à jour les variables CSS --mx / --my de tous les éléments `.c2r-spotlight`
 * sous le curseur, pour créer un effet "spotlight radial" qui suit la souris.
 *
 * - Pas de listener par carte : on utilise un seul listener global et on délègue
 *   via `closest()`. Coût CPU minimal.
 * - Désactivé sur les pointers tactiles / dispositifs sans hover.
 * - À appeler une seule fois (depuis App.js).
 */
export function useSpotlightTracking() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (mq && !mq.matches) return;

    let raf = 0;
    let lastEvent = null;

    const onMove = (e) => {
      lastEvent = e;
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        const ev = lastEvent;
        if (!ev) return;
        const target = ev.target.closest && ev.target.closest('.c2r-spotlight');
        if (!target) return;
        const rect = target.getBoundingClientRect();
        const mx = ((ev.clientX - rect.left) / rect.width) * 100;
        const my = ((ev.clientY - rect.top) / rect.height) * 100;
        target.style.setProperty('--mx', `${mx}%`);
        target.style.setProperty('--my', `${my}%`);
      });
    };

    document.addEventListener('mousemove', onMove, { passive: true });
    return () => {
      document.removeEventListener('mousemove', onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
